import {
  defaultProfilePic,
  SystemSupportedAccountTypes,
} from 'src/environments/constants';
import { IAPIUserInformationDef, IAPIUserDef } from '../interfaces/user';
import { RSCBase, IRSCBaseInstanceParams } from './base/RSCBase';
import { ServiceInjector } from '../components/utils/injector.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RSCAdminAccount } from './RSCAdminAccount';
import { RSCPayrollAccount } from './RSCPayrollAccount';
// import { RSCAdminAccount } from "./RSCAdminAccount";
// import { RSCClientAccount } from "./RSCClientAccount";

// Export others configs
const mainConfig: any = {
  defaultData: { user: { id: 0 } },
  endpoints: {
    // Endpoint para usuario propio, se debe sobre escribir desde afuera cuando sea usuario
    logout: { path: 'user.logout' },
    startLogout: { path: 'user.startLogout' },
    edit: { path: 'user.edit' },
    delete: { path: 'user.delete' },
    login: { path: 'user.login' },
    loginCompleted: { path: 'user.loginCompleted' },
    loginToken: { path: 'user.loginToken' },
    checkLogin: { path: 'user.checkLogin' },
    changePassword: { path: 'user.edit' },
    requestPasswordReset: { path: 'user.requestPasswordReset' },
    verifyPasswordToken: { path: 'user.verifyPasswordToken' },
    resetPassword: { path: 'user.resetPassword' },
  },
};

export class RSCUser extends RSCBase implements IAPIUserInformationDef {
  public static mainConfig = mainConfig;

  user!: IAPIUserDef;
  // client_account: RSCClientAccount;
  admin_account!: RSCAdminAccount;
  payroll_account!: RSCPayrollAccount;

  get id() {
    return this.user.id;
  }
  set id(value: number) {
    if (!this.user) {
      this.user = {} as any;
    }
    this.user.id = value;
  }

  get Name() {
    return this.user.name;
  }

  set Name(value: string) {
    if (!this.user) {
      this.user = {} as any;
    }
    this.user.name = value;
  }

  get Email() {
    return this.user?.email || '';
  }

  set Email(value: string) {
    if (!this.user) {
      this.user = {} as any;
    }
    this.user.email = value;
  }

  get Phone() {
    return this.user?.phone || '';
  }

  set Phone(value: string) {
    if (!this.user) {
      this.user = {} as any;
    }
    this.user.phone = value;
  }

  get AdminAccount() {
    return this.admin_account;
  }

  get Picture() {
    return this.user.picture || defaultProfilePic;
  }

  get HasProfilePicture() {
    return !!this.user?.picture;
  }

  get AccountTypeTranslated() {
    return this?.admin_account?.id > 0 ? 'Administrador' : 'Nómina';
  }

  // set Picture(value: any /* string | Blob */) {
  //   let url;
  //   if (value instanceof Blob) {
  //     const sanitizer = ServiceInjector.injector.get(DomSanitizer);
  //     url = sanitizer.bypassSecurityTrustResourceUrl(
  //       URL.createObjectURL(value),
  //     );
  //   }

  //   if (!this.user) {
  //     this.user = {} as any;
  //   }
  //   this.user.picture = url + '';
  // }

  constructor(cfg: IRSCBaseInstanceParams) {
    super({ ...mainConfig, ...(cfg || {}) });
  }

  /* Signup(params: { password: string, email?: string, usrname?: string, name?: string, tax_id?: string, phone?: string }) {
        return this._request(this.cfg.endpoints.create, params);
    } */

  static Login(email: string, password: string) {
    const item = new RSCUser({});
    return item._request(item.cfg.endpoints.login, {
      email,
      password,
    }) as Promise<string>;
  }

  LoginCompleted(params: { code: string }) {
    return this._request(
      this.cfg.endpoints.loginCompleted,
      params,
    ) as Promise<string>;
  }

  GetLoginToken() {
    return this._request(this.cfg.endpoints.loginToken, {}) as Promise<string>;
  }

  IsLoggedIn() {
    return this.user?.id > 0;
  }

  IsAdmin() {
    return this.admin_account?.Id > 0;
  }

  IsClient() {
    // return this.client_account?.profile?.id > 0;
  }

  ChechLogin() {
    return this._request(this.cfg.endpoints.checkLogin);
  }

  Logout() {
    return this._request(this.cfg.endpoints.logout);
  }

  StartLogout() {
    return this._request(this.cfg.endpoints.startLogout) as Promise<string>;
  }

  /* async Save() {
        // build params
        if (this.user.id > 0) {
            return super.Save();
        } else {
            return super.Create();
        }
    } */

  override async Delete(params: { password: string; reason?: string }) {
    return this._request(this.cfg.endpoints.delete, params);
  }

  protected override _afterFill(data: any) {
    // instance client_account
    // this.client_account =/*  data?.client_account?.id > 0 ? */ (new RSCClientAccount({ fillWith: data?.client_account }))/*  : {} as any */;
    // instance and fill admin_account
    this.admin_account =
      /* data?.admin_account?.id > 0 ? */ new RSCAdminAccount({
        fillWith: data?.admin_account || {},
      }) /* : {} as any */;
    //if (data?.expert_account) {
    //    this.expert_account = /* data?.admin_account?.id > 0 ? */ (new RSCExpertAccount({ fillWith: data?.expert_account })) /* : {} as any */;
    //}
    this.payroll_account = new RSCPayrollAccount({
      fillWith: data?.payroll_account || {},
    });
  }

  protected override _errorCallback(error: any) {
    // handle toasts or any other things
  }

  RequestPasswordReset(params: {
    channel: string /* 'sms'||'email' */;
    channel_value: string;
  }) {
    return this._request(this.cfg.endpoints.requestPasswordReset, params);
  }

  VerifyPasswordToken(params: {
    temporal_token: string;
    channel: string /* 'sms'||'email' */;
    code: string;
  }) {
    return this._request(this.cfg.endpoints.verifyPasswordToken, params);
  }

  ResetPassword(params: { password: string; token: string }) {
    return this._request(this.cfg.endpoints.resetPassword, params);
  }

  ChangePassword(params: { new: string; old: string }) {
    return this._request(this.cfg.endpoints.changePassword, {
      data: JSON.stringify({ pwd: params }),
    });
  }

  /* public static GetCurrentUser() {
        return currentUser;
    } */

  public static GetCurrentUserSync() {
    return currentUser;
  }

  public static SetCurrentUser(config: IRSCBaseInstanceParams) {
    // Update current user
    currentUser._fill(config.fillWith);
    //Set current country based in profile
    const default_country =
      (currentUser as any)[
        (SystemSupportedAccountTypes as any)[RSCBase.accountTypeSync]?.path
      ]?.default_country || {};
    if (default_country?.id > 0) {
      // RSCCountry.SetCurrentCountry({ fillWith: default_country });
    }
  }

  override toJSON(): any {
    return {
      user: this.user,
      // client_account: this.client_account,
      admin_account: this.admin_account,
    };
  }
}

let currentUser: RSCUser = new RSCUser({} as any);
